var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{ name: _vm.to }}},[_c('aad-icon',{staticClass:"back-caret",attrs:{"name":"caret-left"}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }